import { IconButton, styled } from "@mui/material";

import { ReportWarningAlert } from "../ReportWarningAlert";

export const Alert = styled(ReportWarningAlert)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  marginLeft: 20,
  width: "100%",
}));

export const ShowWarningButton = styled(IconButton)(({ theme }) => ({
  // We use absolute positioning to place the icon next to the "Overview" header
  position: "absolute",
  top: -4,
  left: 125,
}));
